import general from './general.json';

const Italian = {
	general
};

export default Italian;
